import { render } from "./ContactComp.vue?vue&type=template&id=2c4ca794"
import script from "./ContactComp.vue?vue&type=script&lang=js"
export * from "./ContactComp.vue?vue&type=script&lang=js"

import "./ContactComp.vue?vue&type=style&index=0&id=2c4ca794&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__